<template>
     <div id="components-layout-demo-custom-trigger"> 
        <v-layout>
            <v-sider collapsible :collapsed="customCollapsed" :trigger="false" :collapsed-width="64">
                <div class="logo">
                    <img :src="logo">
                </div>
                 <div class="table">
                    <v-menu mode="inline" :data="collapsedMenuData" @item-click="openModule" theme="dark" :inline-collapsed="collapsed"></v-menu>
                </div>
            </v-sider>
            <v-layout>
                <v-header :style="{ background: '#fff', padding: 0 }">
                    <v-button class="switch" type="primary" @click="demo">
                        <v-icon :type="collapsed ? 'menu-unfold' : 'menu-fold'" ></v-icon>
                    </v-button>
                    <span class="slogan">您好、欢迎使用七鸥鸥商家管理系统！</span>
                    <span class="avatar">
                         <v-avatar class="touxiang" shape="square" size="large" icon="user" :src="user.avatar"></v-avatar>
                    </span>
                    <span class="name">{{user.username}}</span>
                    <span class="setting">

                            <el-dropdown class="drop">
                                <span class="el-dropdown-link">
                                    设置<i class="el-icon-arrow-down el-icon--right"></i>
                                </span>
                                <el-dropdown-menu slot="dropdown">
                                    <el-dropdown-item v-for="(item,index) in setting" :key="index" :icon="item.icon">
                                        <span  @click="settings(item.id)">{{item.name}}</span>
                                    </el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown>
                    </span>
                </v-header>
                <v-content :style="{ padding: '0 25px' }">
                    <v-breadcrumb class="title" :style="{ margin: '12px 0' }">
                        <v-breadcrumb-item v-for="(item,index) in bread" :key="index" @click.native="breads(item)">{{item.name}}</v-breadcrumb-item>
                    </v-breadcrumb>
                    <div style="padding: 24px; background: #fff; min-height: 360px;">
                             <component :is="componentType" />
                    </div>
                </v-content>
                <v-footer :style="{ textAlign: 'center' }">
                    Ant Design ©2020 成都恒诚极度科技有限公司
                </v-footer>
            </v-layout>
        </v-layout>
    </div>
</template>
<script>

//酒店模块
import index from '../Hotel/index' //主页
import houseState from '../Hotel/product/houseState/houseState' //房态维护
import housePrice from '../Hotel/product/houseState/housePrice' //房价维护
import houseNew from '../Hotel/product/houseState/houseNew' //录入新商品
import houseRule from '../Hotel/product/houseState/houseRule' //售卖规则
import houseStock from '../Hotel/product/houseState/houseStock' //库存管理
import orderList from '../Hotel/product/order/orderList' //订单列表
import orderInfo from '../Hotel/product/order/orderInfo' //订单详情
import sellSum from '../Hotel/product/sell/sellSum' //销售统计
import sellList from '../Hotel/product/sell/sellList' //平台统计
import sellErrer from '../Hotel/product/sell/sellErrer' //无效订单
import commentList from '../Hotel/product/comment/commentList' //评论列表
import storeManager from '../Hotel/product/store/storeManager' //分店管理
import storeAdd from '../Hotel/product/store/storeAdd' //添加分店
import storeInfo from '../Hotel/product/setup/storeInfo' //店铺信息
import userAdmin from '../Hotel/product/setup/userAdmin' //员工信息
import userName from '../Hotel/product/setup/userName' //账号设置

//商城模块
import store from '../Store/Store' //商品详情
import storeOrder from '../Store/Order/Order' //商品订单

//跟团
import tours from '../Vip/Tours/Tours' //线路行程
import toursInfo from '../Vip/Tours/ToursInfo' //线路管理

//优惠券
import memberList from '../Member/CouponList' //优惠券列表
import sendCard from '../Member/SendCard' //派发礼券

//会员卡
import sendCards from '../Card/SendCard' //会员开通
import cardList from '../Card/CardList' //会员查询



import { createNamespacedHelpers } from 'vuex'
const {mapState, mapGetters, mapMutations, mapActions } = createNamespacedHelpers('user')
export default {
    data(){
        return{
        componentType:'cardList',
        user:{
        },
        logo:'https://7ouou-guide.oss-cn-chengdu.aliyuncs.com/common/Hotel/on.png',
        logoIs:true,
        collapsed: false,
        customCollapsed:false,
        collapsedMenuData: [],
        setting: [
            {id:1,name: '个人中心',icon:'el-icon-plus'},
            {id:2,name: '切换模块',icon:'el-icon-plus'},
            {id:3,name: '切换账号',icon:'el-icon-plus'},
            {id:4,name: '退出',icon:'el-icon-plus'},
         ],
        bread:[],
        }
    },
    components:{
        index,houseState,housePrice,houseNew,houseRule,houseStock,orderList,orderInfo,sellSum,sellList,sellErrer,commentList,storeManager,storeAdd,storeInfo,userAdmin,userName,tours,toursInfo,
        store,storeOrder,
        memberList,sendCard,sendCards,cardList
        },
    computed:{
      ...mapState({
          userVuex:state=>state.user
      })
    },
    mounted(){
       this.userInfo()
    },
    methods:{
       ...mapMutations(['addUser']),
      
      userInfo(){
          var user =  JSON.parse(localStorage.getItem('user'))
          var token = localStorage.getItem('token')
          var optionId = localStorage.getItem('optionId')
          this.user =  user
        //选择相应的导航栏
        this.joker.user.selectNav(optionId).then(res=>{
            this.collapsedMenuData = res.content
            this.componentType = res.content[0].routeUrl
            console.log(res)
        }).catch(res=>{
            console.log(res)
        })
      },
      //切换组件
      openModule(val){
          console.log(val)
          this.bread = val
          if(val.length==1){
              this.componentType = val[0].routeUrl
          }else{
              this.componentType = val[1].routeUrl
          }
      },
      //导航切换
      breads(item){
          this.componentType = item.routeUrl
      },
      toggle() {
           this.customCollapsed = !this.customCollapsed;
      },
      demo(){
          this.logoIs = !this.logoIs
          this.logo =  this.logoIs ? 'https://7ouou-guide.oss-cn-chengdu.aliyuncs.com/common/Hotel/on.png' : 'https://7ouou-guide.oss-cn-chengdu.aliyuncs.com/common/Hotel/30.png'
          this.collapsed = !this.collapsed
          this.toggle()
      },

      demos(url){
          console.log("来了"+url)
          this.componentType = url
      },

      settings(id){
          console.log("进来了")
          console.log(id)
          switch(id){
              case 1:
                  break;
              case 2:
                  this.$router.replace('/Option')
                  break;
              case 3:
                  break;
              case 4:
                  break;
          }
      },
    }
}
</script>

<style scoped>


    #components-layout-demo-custom-trigger .trigger {
        font-size: 18px;
        line-height: 64px;
        padding: 0 16px;
        cursor: pointer;
        transition: color .3s;
    }
    #components-layout-demo-custom-trigger .trigger:hover {
        color: #108ee9;
    }
    #components-layout-demo-custom-trigger .logo {
        height: 32px;
        background: #333;
        border-radius: 6px;
        margin: 16px;
    }
    #components-layout-demo-custom-trigger .ant-layout-sider-collapsed .anticon {
        font-size: 16px;
    }
    #components-layout-demo-custom-trigger .ant-layout-sider-collapsed .nav-text {
        display: none;
    }

    .el-dropdown-link {
    cursor: pointer;
    color: #409EFF;
  }
  .el-icon-arrow-down {
    font-size: 12px;
  }
  .demonstration {
    display: block;
    color: #8492a6;
    font-size: 14px;
    margin-bottom: 20px;
  }


.title{
    text-align: left
}

.touxiang{
   display: inline-block;
   vertical-align:middle
}

.slogan{
    margin-left: 35%;
}

.avatar{

    margin-left: 35%;
}

.name{
     margin-left: 1%;
}

.setting{
    margin-left: 1%;
}

.drop{
    width: 5%;
}

</style>


// WEBPACK FOOTER //
// src/components/Home/Home.vue